module.exports = __webpack_public_path__ + "img/logo.00669c9c.png";